var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "warpp" },
    [
      _c("div", { staticClass: "buts" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.customerTypeSee.type === _vm.typeObj.set.code,
                expression: "customerTypeSee.type === typeObj.set.code",
              },
              {
                name: "permit",
                rawName: "v-permit:remove",
                value: "btn:customer-managements:list:audit",
                expression: "'btn:customer-managements:list:audit'",
                arg: "remove",
              },
            ],
          },
          [
            _vm.ruleForm.auditState === 0
              ? _c(
                  "el-button",
                  {
                    attrs: { size: "small", type: "primary" },
                    on: {
                      click: function ($event) {
                        _vm.dialog.examineVisible = true
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("customerManagements.AccountAudit")) + " "
                    ),
                  ]
                )
              : [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "permit",
                          rawName: "v-permit:remove",
                          value: "btn:customer-managements:list:lock",
                          expression: "'btn:customer-managements:list:lock'",
                          arg: "remove",
                        },
                      ],
                    },
                    [
                      _vm.ruleForm.lockState === 1
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "warning" },
                              on: {
                                click: function ($event) {
                                  return _vm.setLockState(0)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("customerManagements.AccountOpening")
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _c(
                            "el-button",
                            {
                              attrs: { type: "danger" },
                              on: {
                                click: function ($event) {
                                  return _vm.setLockState(1)
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("customerManagements.AccountDisabled")
                                ) + " "
                              ),
                            ]
                          ),
                    ],
                    1
                  ),
                ],
          ],
          2
        ),
      ]),
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: { model: _vm.ruleForm, rules: _vm.rules, size: "small" },
        },
        [
          _c(
            "el-collapse",
            {
              on: { change: _vm.handleChange },
              model: {
                value: _vm.activeNames,
                callback: function ($$v) {
                  _vm.activeNames = $$v
                },
                expression: "activeNames",
              },
            },
            [
              _c(
                "el-collapse-item",
                {
                  attrs: {
                    title: _vm.$t("customerManagements.accountInformation"),
                    name: "1",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "customerManagements.customerType"
                                ),
                                prop: "source",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "operationCenter.PleaseSelect"
                                    ),
                                    clearable: "",
                                  },
                                  on: { change: _vm.changeSource },
                                  model: {
                                    value: _vm.ruleForm.source,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "source", $$v)
                                    },
                                    expression: "ruleForm.source",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "customerManagements.enterprise"
                                      ),
                                      value: "corporation",
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "customerManagements.personal"
                                      ),
                                      value: "person",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "customerManagements.ApprovalStatus"
                                ),
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "operationCenter.PleaseSelect"
                                    ),
                                    clearable: "",
                                    disabled: "",
                                    filterable: "",
                                  },
                                  model: {
                                    value: _vm.ruleForm.auditState,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "auditState", $$v)
                                    },
                                    expression: "ruleForm.auditState",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    key: 2,
                                    attrs: {
                                      label: _vm.$t(
                                        "customerManagements.NotAudit"
                                      ),
                                      value: 0,
                                    },
                                  }),
                                  _c("el-option", {
                                    key: 3,
                                    attrs: {
                                      label: _vm.$t(
                                        "customerManagements.approved"
                                      ),
                                      value: 1,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "customerManagements.AccountStatus"
                                ),
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "operationCenter.PleaseSelect"
                                    ),
                                    clearable: "",
                                    disabled: "",
                                    filterable: "",
                                  },
                                  model: {
                                    value: _vm.ruleForm.lockState,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "lockState", $$v)
                                    },
                                    expression: "ruleForm.lockState",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    key: 2,
                                    attrs: {
                                      label: _vm.$t(
                                        "customerManagements.enable"
                                      ),
                                      value: 0,
                                    },
                                  }),
                                  _c("el-option", {
                                    key: 3,
                                    attrs: {
                                      label: _vm.$t(
                                        "customerManagements.Disable"
                                      ),
                                      value: 1,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("changepwd.accountLevel"),
                                prop: "level",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "operationCenter.PleaseSelect"
                                    ),
                                    clearable: "",
                                  },
                                  on: { change: _vm.changeLevel },
                                  model: {
                                    value: _vm.ruleForm.level,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "level", $$v)
                                    },
                                    expression: "ruleForm.level",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    key: "1",
                                    attrs: {
                                      label: _vm.$t("changepwd.oneLeave"),
                                      value: 1,
                                    },
                                  }),
                                  _c("el-option", {
                                    key: "2",
                                    attrs: {
                                      label: _vm.$t("changepwd.twoLeave"),
                                      value: 2,
                                    },
                                  }),
                                  _c("el-option", {
                                    key: "3",
                                    attrs: {
                                      label: _vm.$t("changepwd.levelThree"),
                                      value: 3,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      [2, 3].includes(_vm.ruleForm.level)
                        ? _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("changepwd.superiorAccount"),
                                    prop: "parentId",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "operationCenter.PleaseSelect"
                                        ),
                                        clearable: "",
                                        filterable: "",
                                      },
                                      on: { change: _vm.getParentOptions },
                                      model: {
                                        value: _vm.ruleForm.parentId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "parentId",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.parentId",
                                      },
                                    },
                                    _vm._l(
                                      _vm.parentAccountList,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.id,
                                          attrs: {
                                            label: item.username,
                                            value: item.id,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "customerManagements.customerChannel"
                                ),
                                prop: "channel",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "operationCenter.PleaseSelect"
                                    ),
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.ruleForm.channel,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "channel", $$v)
                                    },
                                    expression: "ruleForm.channel",
                                  },
                                },
                                _vm._l(_vm.channelList, function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.value,
                                      value: item.key,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "customerManagements.accountName"
                                ),
                                prop: "username",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: _vm.disabled,
                                  placeholder: _vm.$t(
                                    "customerManagements.setConciseAccountName"
                                  ),
                                  maxlength: "30",
                                  "show-word-limit": "",
                                },
                                on: { input: _vm.handleUsernameInput },
                                model: {
                                  value: _vm.ruleForm.username,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.ruleForm,
                                      "username",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "ruleForm.username",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "customerManagements.AccountNickname"
                                ),
                                prop: "customerAlias",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t(
                                    "customerManagements.pleaseInput"
                                  ),
                                  readonly: _vm.readonly,
                                },
                                model: {
                                  value: _vm.ruleForm.customerAlias,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.ruleForm,
                                      "customerAlias",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "ruleForm.customerAlias",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("customerManagements.site"),
                                prop: "siteId",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.readonly,
                                    placeholder: _vm.$t(
                                      "operationCenter.PleaseSelect"
                                    ),
                                    clearable: "",
                                    filterable: "",
                                  },
                                  model: {
                                    value: _vm.ruleForm.siteId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "siteId", $$v)
                                    },
                                    expression: "ruleForm.siteId",
                                  },
                                },
                                _vm._l(_vm.siteIdList, function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: { label: item.name, value: item.id },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("changepwd.customerSource"),
                                prop: "customerSource",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "operationCenter.PleaseSelect"
                                    ),
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.ruleForm.customerSource,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.ruleForm,
                                        "customerSource",
                                        $$v
                                      )
                                    },
                                    expression: "ruleForm.customerSource",
                                  },
                                },
                                _vm._l(_vm.resCusList, function (item) {
                                  return _c("el-option", {
                                    key: item.key,
                                    attrs: {
                                      label: item.value,
                                      value: item.key,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "fulfillmentMode" } },
                            [
                              _c(
                                "template",
                                { slot: "label" },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { "margin-right": "1px" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("changepwd.fulfillmentMode")
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        "append-to-body": true,
                                        content: _vm.$t(
                                          "changepwd.fullOrderFulfillmentDesc"
                                        ),
                                        effect: "dark",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "custom-form-item" },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question custom-tooltip-icon",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "operationCenter.PleaseSelect"
                                    ),
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.ruleForm.fulfillmentMode,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.ruleForm,
                                        "fulfillmentMode",
                                        $$v
                                      )
                                    },
                                    expression: "ruleForm.fulfillmentMode",
                                  },
                                },
                                _vm._l(_vm.resModeList, function (item) {
                                  return _c("el-option", {
                                    key: item.key,
                                    attrs: {
                                      label: item.value,
                                      value: item.key,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm.customerTypeSee.type === _vm.typeObj.add.code
                        ? _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "customerManagements.accountPassword"
                                    ),
                                    prop: "password",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      disabled: _vm.disabled,
                                      maxlength: 12,
                                      minlength: 8,
                                      placeholder: _vm.$t(
                                        "customerManagements.passwordPrompt"
                                      ),
                                      "show-word-limit": "",
                                    },
                                    model: {
                                      value: _vm.ruleForm.password,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ruleForm,
                                          "password",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "ruleForm.password",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.ruleForm.source === "corporation"
                ? _c(
                    "el-collapse-item",
                    {
                      attrs: {
                        title: _vm.$t(
                          "customerManagements.enterpriseInformation"
                        ),
                        name: "2",
                      },
                    },
                    [
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("changepwd.companyName"),
                                      rules: {
                                        required: true,
                                        message: _vm.$t(
                                          "placeOrder.pleaseInput"
                                        ),
                                        trigger: ["blur", "change"],
                                      },
                                      prop: "company",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "customerManagements.pleaseEnterTheFullCompanyName"
                                        ),
                                        readonly: _vm.readonly,
                                        maxlength: "100",
                                        "show-word-limit": "",
                                      },
                                      model: {
                                        value: _vm.ruleForm.company,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "company",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "ruleForm.company",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    key: _vm.ruleForm.source,
                                    attrs: {
                                      label: _vm.$t(
                                        "customerManagements.cnpjMother"
                                      ),
                                      prop: "cnpjMother",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "customerManagements.pleaseInput"
                                        ),
                                        readonly: _vm.readonly,
                                        clearable: "",
                                      },
                                      on: {
                                        blur: function ($event) {
                                          return _vm.checkCnpj(
                                            _vm.ruleForm.cnpjMother,
                                            _vm.ruleForm.id
                                          )
                                        },
                                        input: _vm.handleCnpjMother,
                                      },
                                      model: {
                                        value: _vm.ruleForm.cnpjMother,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "cnpjMother",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.cnpjMother",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "changepwd.operatingLicense"
                                      ),
                                    },
                                  },
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        ref: "upload",
                                        staticClass: "avatar-uploader",
                                        attrs: {
                                          accept: _vm.acceptStr,
                                          "before-upload":
                                            _vm.resumeBeforeAvatarUpload,
                                          "file-list": _vm.fileList,
                                          "http-request": _vm.resumeUpload,
                                          limit: 4,
                                          multiple: false,
                                          "on-remove": _vm.removeFile,
                                          action: "",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              size: "small",
                                              type: "primary",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "customerManagements.clickUpload"
                                                )
                                              ) + " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "el-upload__tip",
                                            attrs: { slot: "tip" },
                                            slot: "tip",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "customerManagements.uploadPicturesNoMoreThan5MB"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.fileList.length > 0 ||
                                _vm.PDFFileList.length > 0
                                  ? _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "customerManagements.attachmentHasBeenUploaded"
                                          ),
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "demo-image__preview",
                                          },
                                          [
                                            _vm._l(
                                              _vm.fileList,
                                              function (item, index) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass: "imglist",
                                                    staticStyle: {
                                                      display: "inline-block",
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticStyle: {
                                                        width: "100px",
                                                        height: "100px",
                                                        "margin-right": "10px",
                                                      },
                                                      attrs: {
                                                        src: item.url,
                                                        alt: "",
                                                      },
                                                    }),
                                                  ]
                                                )
                                              }
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "ullist" },
                                              [
                                                _vm._l(
                                                  _vm.PDFFileList,
                                                  function (item) {
                                                    return [
                                                      _c(
                                                        "span",
                                                        {
                                                          key: item.url,
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleSee(
                                                                item.url
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(item.name)
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                          ],
                                          2
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      label: _vm.$t("placeOrder.State"),
                                      rules: {
                                        required: true,
                                        message: _vm.$t(
                                          "GlobalSetObj.pleaseChoose"
                                        ),
                                        trigger: ["blur", "change"],
                                      },
                                      prop: "state",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "placeOrder.pleaseInput"
                                          ),
                                          readonly: _vm.readonly,
                                          clearable: "",
                                          filterable: "",
                                        },
                                        on: {
                                          change: _vm.changeState,
                                          focus: _vm.getAddress,
                                        },
                                        model: {
                                          value: _vm.ruleForm.state,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.ruleForm, "state", $$v)
                                          },
                                          expression: "ruleForm.state",
                                        },
                                      },
                                      _vm._l(_vm.StateList, function (item) {
                                        return _c("el-option", {
                                          key: item.id,
                                          attrs: {
                                            label: item.shortName,
                                            value: item.shortName,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      label: _vm.$t("placeOrder.city"),
                                      rules: {
                                        required: true,
                                        message: _vm.$t(
                                          "GlobalSetObj.pleaseChoose"
                                        ),
                                        trigger: ["blur", "change"],
                                      },
                                      prop: "city",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "placeOrder.pleaseChoose"
                                          ),
                                          readonly: _vm.readonly,
                                          "remote-method": _vm.getSenderCity,
                                          clearable: "",
                                          filterable: "",
                                          remote: "",
                                          "reserve-keyword": "",
                                        },
                                        on: {
                                          "visible-change": function ($event) {
                                            return _vm.getSenderCity()
                                          },
                                        },
                                        model: {
                                          value: _vm.ruleForm.city,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.ruleForm, "city", $$v)
                                          },
                                          expression: "ruleForm.city",
                                        },
                                      },
                                      _vm._l(_vm.cityList, function (item) {
                                        return _c("el-option", {
                                          key: item.id,
                                          attrs: {
                                            label: item.name,
                                            value: item.name,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      label: _vm.$t("newOrder.Street"),
                                      prop: "street",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "placeOrder.pleaseInput"
                                        ),
                                        readonly: _vm.readonly,
                                        clearable: "",
                                        maxlength: "50",
                                        "show-word-limit": "",
                                      },
                                      model: {
                                        value: _vm.ruleForm.street,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.ruleForm, "street", $$v)
                                        },
                                        expression: "ruleForm.street",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      label: _vm.$t("placeOrder.HouseNumber"),
                                      prop: "houseNumber",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "placeOrder.pleaseInput"
                                        ),
                                        readonly: _vm.readonly,
                                        clearable: "",
                                        maxlength: "10",
                                        "show-word-limit": "",
                                      },
                                      model: {
                                        value: _vm.ruleForm.houseNumber,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "houseNumber",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.houseNumber",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "placeOrder.detailedAddress"
                                      ),
                                      prop: "address",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "customerManagements.pleaseInput"
                                        ),
                                        readonly: _vm.readonly,
                                        maxlength: "200",
                                        "show-word-limit": "",
                                      },
                                      model: {
                                        value: _vm.ruleForm.address,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.ruleForm, "address", $$v)
                                        },
                                        expression: "ruleForm.address",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      label: _vm.$t(
                                        "placeOrder.addressComplement"
                                      ),
                                      prop: "complement",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "placeOrder.pleaseInput"
                                        ),
                                        readonly: _vm.readonly,
                                        clearable: "",
                                        maxlength: "50",
                                        "show-word-limit": "",
                                      },
                                      model: {
                                        value: _vm.ruleForm.complement,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "complement",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.complement",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "changepwd.ieStateRegistration"
                                      ),
                                      prop: "ieNumber",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "customerManagements.pleaseInput"
                                        ),
                                        readonly: _vm.readonly,
                                        clearable: "",
                                        maxlength: "18",
                                      },
                                      model: {
                                        value: _vm.ruleForm.ieNumber,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "ieNumber",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.ieNumber",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("orderDetails.zipcode"),
                                      prop: "zipcode",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "customerManagements.pleaseInput"
                                        ),
                                        readonly: _vm.readonly,
                                        clearable: "",
                                        maxlength: "8",
                                      },
                                      on: {
                                        blur: function ($event) {
                                          return _vm.zipcodeChange(
                                            _vm.ruleForm.zipcode
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.ruleForm.zipcode,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.ruleForm, "zipcode", $$v)
                                        },
                                        expression: "ruleForm.zipcode",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 16 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "changepwd.productRequirements"
                                      ),
                                      prop: "productRequirement",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "customerManagements.pleaseInput"
                                        ),
                                        readonly: _vm.readonly,
                                        rows: 3,
                                        clearable: "",
                                        type: "textarea",
                                      },
                                      model: {
                                        value: _vm.ruleForm.productRequirement,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "productRequirement",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "ruleForm.productRequirement",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                    ],
                    2
                  )
                : _vm._e(),
              _c(
                "el-collapse-item",
                {
                  attrs: {
                    title: _vm.$t("changepwd.contactInformation"),
                    name: "3",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("company.contact"),
                                prop: "coPrincipalName",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t(
                                    "customerManagements.pleaseInput"
                                  ),
                                  readonly: _vm.readonly,
                                },
                                model: {
                                  value: _vm.ruleForm.coPrincipalName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.ruleForm,
                                      "coPrincipalName",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "ruleForm.coPrincipalName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 16 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "orderCenterCont.CertificateCode"
                                ),
                                prop: "coPrincipalIdentityCard",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t(
                                    "customerManagements.pleaseInput"
                                  ),
                                  readonly: _vm.readonly,
                                },
                                model: {
                                  value: _vm.ruleForm.coPrincipalIdentityCard,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.ruleForm,
                                      "coPrincipalIdentityCard",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression:
                                    "ruleForm.coPrincipalIdentityCard",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("GlobalSetObj.MobilePhone"),
                                prop: "customerPhone",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t(
                                    "customerManagements.pleaseInput"
                                  ),
                                  readonly: _vm.readonly,
                                  maxlength: "20",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.ruleForm.customerPhone,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.ruleForm,
                                      "customerPhone",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "ruleForm.customerPhone",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("GlobalSetObj.userPhone"),
                                prop: "coPrincipalTel",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t(
                                    "customerManagements.pleaseInput"
                                  ),
                                  readonly: _vm.readonly,
                                  maxlength: "20",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.ruleForm.coPrincipalTel,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.ruleForm,
                                      "coPrincipalTel",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "ruleForm.coPrincipalTel",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("changepwd.wechatQQWhatsapp"),
                                prop: "coPrincipalQq",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t(
                                    "customerManagements.pleaseInput"
                                  ),
                                  readonly: _vm.readonly,
                                  maxlength: "20",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.ruleForm.coPrincipalQq,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.ruleForm,
                                      "coPrincipalQq",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "ruleForm.coPrincipalQq",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("login.email"),
                                prop: "customerEmail",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t(
                                    "operationCenter.PleaseEnterTheContent"
                                  ),
                                  readonly: _vm.readonly,
                                },
                                model: {
                                  value: _vm.ruleForm.customerEmail,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "customerEmail", $$v)
                                  },
                                  expression: "ruleForm.customerEmail",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-form-item", [
            _c(
              "div",
              {
                staticClass: "flx-end",
                staticStyle: { "margin-top": "15px", width: "100%" },
              },
              [
                _vm.customerTypeSee.type === _vm.typeObj.add.code ||
                _vm.customerTypeSee.type === _vm.typeObj.edit.code
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.onSubmit("ruleForm")
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("customerManagements.submit")) + " "
                            ),
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.resetForm("ruleForm")
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("customerManagements.reset")) + " "
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      {
                        staticClass: "flx-end",
                        staticStyle: { "margin-left": "10px" },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit:remove",
                                value: "btn:customer-managements:list:edit",
                                expression:
                                  "'btn:customer-managements:list:edit'",
                                arg: "remove",
                              },
                            ],
                            attrs: { type: "success" },
                            on: {
                              click: function ($event) {
                                return _vm.onEditBtn("ruleForm")
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("orderDetails.edit")) + " ")]
                        ),
                        _vm.ruleForm.auditState !== 0
                          ? _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "permit",
                                    rawName: "v-permit:remove",
                                    value: "btn:customer-managements:list:lock",
                                    expression:
                                      "'btn:customer-managements:list:lock'",
                                    arg: "remove",
                                  },
                                ],
                                staticStyle: { margin: "0 10px" },
                              },
                              [
                                _vm.ruleForm.lockState === 1
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "warning" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.setLockState(0)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "customerManagements.enable"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "el-button",
                                      {
                                        attrs: { type: "danger" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.setLockState(1)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "customerManagements.Disable"
                                            )
                                          ) + " "
                                        ),
                                      ]
                                    ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit:remove",
                                value:
                                  "btn:customer-managements:list:reset-pwd",
                                expression:
                                  "'btn:customer-managements:list:reset-pwd'",
                                arg: "remove",
                              },
                            ],
                            attrs: { type: "danger" },
                            on: { click: _vm.resetPwd },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("userManage.resetPassword")) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
              ]
            ),
          ]),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            title: _vm.$t("customerManagements.tips"),
            visible: _vm.dialog.examineVisible,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "examineVisible", $event)
            },
          },
        },
        [
          _c("p", { staticClass: "dialog" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("customerManagements.IfAgreeAudit"))),
            ]),
            _c("span", [
              _vm._v(
                _vm._s(_vm.$t("customerManagements.NoteDefaultAccount")) + " "
              ),
              _c("strong", [
                _vm._v(_vm._s(_vm.$t("customerManagements.Disable"))),
              ]),
              _vm._v(" " + _vm._s(_vm.$t("customerManagements.accountState"))),
            ]),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialog.examineVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("customerManagements.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.setAuditState },
                },
                [_vm._v(_vm._s(_vm.$t("customerManagements.confirm")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            title: _vm.$t("customerManagements.tips"),
            visible: _vm.dialog.lockVisible,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "lockVisible", $event)
            },
          },
        },
        [
          _c("p", { staticClass: "dialog" }, [
            _c("span", [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("customerManagements.ConfirmOperationAccount")
                  ) +
                  " "
              ),
              _c("strong", [
                _vm._v(
                  _vm._s(
                    _vm.dialog.obj.type == 0
                      ? _vm.$t("customerManagements.enable")
                      : _vm.$t("customerManagements.Disable")
                  )
                ),
              ]),
              _vm._v(
                " " + _vm._s(_vm.$t("customerManagements.operation")) + " "
              ),
            ]),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialog.lockVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("customerManagements.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.determineLockState },
                },
                [_vm._v(_vm._s(_vm.$t("customerManagements.confirm")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }